export const getServiceRequestsForPayment = (state) =>
  state.serviceRequestsForPayment;


